import React, { useEffect, useRef, useState } from 'react';
import classnames from 'classnames';
import { FormattedMessage } from 'react-intl';
import { Popover } from '../../../../global/popover/popover';
import DefaultButton from '../../../../global/default-button/default-button';
import { AssetsBiographyForm } from './assets-biography-form.container';
import { HTML_TAGS_REG_EXP, SPACE_IN_BEGIN_REG_EXP } from '../../../../../constants/regex.constants';

import './assets-biography-form.scss';

interface IProps {
    accountId: number;
    eventId: number;
    organizationId?: number | null;
    attendeeId?: number | null;
    biography: string;
    updateAttendeePermission: boolean;
    setSpeakerBiography: (biography: string, organizationId: number, attendeeId: number) => void;
}

const AssetsBiographyFormWrapper = (props: IProps) => {
    const {
        accountId,
        eventId,
        organizationId = null,
        attendeeId = null,
        biography = '',
        updateAttendeePermission,
        setSpeakerBiography
    } = props;

    const [isViewsOpen, setIsViewsOpen] = useState<boolean>(false);
    const [elementPosition, setElementPosition] = useState<{ element: number; window: number }>(null);
    const viewsRef = useRef(null);

    useEffect(() => {
        if (isViewsOpen) {
            setElementPosition({
                element: window.scrollY + viewsRef.current.getBoundingClientRect().bottom,
                window: window.scrollY + document.documentElement.clientHeight
            });
        }
    }, [isViewsOpen]);

    const biographyText = biography?.replace(HTML_TAGS_REG_EXP, ' ').replace(SPACE_IN_BEGIN_REG_EXP, '');

    return (
        <div
            className='assets-biography-button-wrapper'
            ref={viewsRef}
        >
            {
                biography
                    ? <DefaultButton
                        text={biographyText?.slice(0, 35) || ''}
                        className={classnames('download-item add-attendee-btn visible-on-hover', isViewsOpen && 'active')}
                        modifier='row'
                        onClick={() => setIsViewsOpen(true)}
                        withEllipsis
                    />
                    : (updateAttendeePermission &&
                        <DefaultButton
                            className='assets-list-item__upload-biography-button'
                            onClick={() => setIsViewsOpen(true)}
                            text={
                                <FormattedMessage
                                    id='oe.assets.addBiography'
                                    description='Button label'
                                    defaultMessage='+ Add Biography'
                                />
                            }
                        />)
            }

            <Popover
                isOpen={isViewsOpen}
                buttonRef={viewsRef}
                withCloseIcon
                onClose={() => setIsViewsOpen(false)}
                onClickOutside={e => {
                    const target = (e.target as Element)?.closest('.assets-biography-form-in-popover');
                    /* e.composedPath - don`t close popup by scrolling */
                    if (!target && e.composedPath().length > 3) {
                        setIsViewsOpen(false);
                    }
                }}
                customWidth={382}
                padding={0}
                align='start'
                position='bottom'
                customTop={elementPosition && ((elementPosition.element + 300) > elementPosition.window ? -250 : null)}
            >
                <AssetsBiographyForm
                    accountId={accountId}
                    eventId={eventId}
                    organizationId={organizationId}
                    attendeeId={attendeeId}
                    biography={biography}
                    closeAssetsBiographyPopup={() => setIsViewsOpen(false)}
                    setSpeakerBiography={setSpeakerBiography}
                />
            </Popover>
        </div>
    );
};


export { AssetsBiographyFormWrapper };